type IconProps = React.HTMLAttributes<SVGElement>;
export const TooltipArrow = (props: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none" {...props}>
    <path
      d="M11 0L-9.53674e-07 9.61651e-07L9.26285 10.1049C9.87911 10.7772 11 10.3412 11 9.4292L11 0Z"
      fill="currentColor"
    />
  </svg>
);
